document.addEventListener("DOMContentLoaded", () => {
  const video = document.getElementById("caVideo");
  const icon = document.getElementById("caVideoIcon");

  // Toggle audio and icon on click
  video.addEventListener("click", () => {
    if (video.muted) {
      video.muted = false;
      icon.textContent = "🔊";
      icon.style.opacity = 1;
      video.play();
    } else {
      video.muted = true;
      icon.textContent = "🔇";
      icon.style.opacity = 0.8;
      video.pause();
    }
  });

  // Optional: small fade animation for icon visibility
  video.addEventListener("mouseenter", () => icon.style.opacity = 1);
  video.addEventListener("mouseleave", () => icon.style.opacity = 0.7);
});